// @generated by protoc-gen-connect-web v0.6.0 with parameter "target=ts,ts_nocheck=false"
// @generated from file api/scribe/svc_note_list.proto (package com.diagnocat.scribe, syntax proto3)
/* eslint-disable */

import { CreateNoteListReq, CreateNoteListResp, DeleteNoteListReq, DeleteNoteListResp, GetNoteListReq, GetNoteListResp, ListNoteListsReq, ListNoteListsResp, ListNoteListUsageReq, ListNoteListUsageResp, RestoreNoteListReq, RestoreNoteListResp, UpdateNoteListReq, UpdateNoteListResp } from "./svc_note_list_pb.js";
import { MethodKind } from "@bufbuild/protobuf";

/**
 * NoteListService manages the shared value lists block-note templates
 * reference (NoteListRefBlock). Lists are owned by an organization; a refused
 * write carries DocumentTemplateIssue details.
 *
 * @generated from service com.diagnocat.scribe.NoteListService
 */
export const NoteListService = {
  typeName: "com.diagnocat.scribe.NoteListService",
  methods: {
    /**
     * @generated from rpc com.diagnocat.scribe.NoteListService.Get
     */
    get: {
      name: "Get",
      I: GetNoteListReq,
      O: GetNoteListResp,
      kind: MethodKind.Unary,
    },
    /**
     * The lists an organization can reference.
     *
     * @generated from rpc com.diagnocat.scribe.NoteListService.List
     */
    list: {
      name: "List",
      I: ListNoteListsReq,
      O: ListNoteListsResp,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.diagnocat.scribe.NoteListService.Create
     */
    create: {
      name: "Create",
      I: CreateNoteListReq,
      O: CreateNoteListResp,
      kind: MethodKind.Unary,
    },
    /**
     * Replaces name, description and items. The edit reaches every template that
     * references the list. Refused when a removed or renamed value is a
     * show_when value in an active or draft template of the organization.
     *
     * @generated from rpc com.diagnocat.scribe.NoteListService.Update
     */
    update: {
      name: "Update",
      I: UpdateNoteListReq,
      O: UpdateNoteListResp,
      kind: MethodKind.Unary,
    },
    /**
     * Soft delete. Refused while an active or draft template of the
     * organization references the list; pinned old versions still read it.
     *
     * @generated from rpc com.diagnocat.scribe.NoteListService.Delete
     */
    delete: {
      name: "Delete",
      I: DeleteNoteListReq,
      O: DeleteNoteListResp,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.diagnocat.scribe.NoteListService.Restore
     */
    restore: {
      name: "Restore",
      I: RestoreNoteListReq,
      O: RestoreNoteListResp,
      kind: MethodKind.Unary,
    },
    /**
     * The active and draft template versions that reference the list.
     *
     * @generated from rpc com.diagnocat.scribe.NoteListService.ListUsage
     */
    listUsage: {
      name: "ListUsage",
      I: ListNoteListUsageReq,
      O: ListNoteListUsageResp,
      kind: MethodKind.Unary,
    },
  }
} as const;

